module.exports = __webpack_public_path__ + "static/img/profileImg.a64072a7.png";